module.exports = "<div class=\"tableModal\">\n    <div class=\"modal-header\">\n        <h3>{{title}}</h3>\n    </div>\n    <div class=\"tab-inner\" id=\"descModalID\">\n        <table id=\"pageTwoInfoTable\">\n            <tr><th ng-repeat=\"title in data.columns\">{{title.name}}</th></tr>\n            <tr ng-repeat=\"row in data.rows\"><td ng-repeat=\"col in row\">{{col}}</td></tr>\n        </table>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/ioc_notifications/modal_showall.html
 ** module id = 730
 ** module chunks = 0
 **/